'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'AuditRestService',
    function ($modal, AuditRestService) {

        return {
            select: select,
            create: create,
            edit: edit,
            api: AuditRestService
        };

        function select(staff, filters, def) {

        }

        function create(def) {

        }

        function edit(staff) {

        }

    }];